var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('img',{attrs:{"src":require("@/assets/alterna-icon@2x.png"),"alt":"Alterna AI"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }